import React from 'react'
import Button from '@Components/Buttons/Button'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import Popup from '@Components/Popups/Popup'

export interface ClaimConfirmationPopupProps {
    closeModal: () => void
    submissionLoading: boolean
    submitClaim: () => void
    isInternal: boolean
}

const ClaimConfirmationPopup = (props: ClaimConfirmationPopupProps) => {
    const { closeModal, submissionLoading, submitClaim, isInternal } = props
    return (
        <Popup onClose={closeModal}>
            <div className="modal-content">
                <h2>Confirm Claim</h2>
                {submissionLoading ? (
                    <PointPreloader />
                ) : (
                    <>
                        <p>
                            Click <b>Claim</b> below to submit your claim on this work to The MLC. To review or edit any
                            information, click <b>Back.</b>
                        </p>
                        <div className="button-row">
                            <Button mainColor type="secondary" onClick={closeModal}>
                                Back
                            </Button>
                            <Button mainColor type="primary" disabled={isInternal} onClick={() => submitClaim()}>
                                Claim
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </Popup>
    )
}

export default ClaimConfirmationPopup
